import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";

import { goTo, handleChange, handleResultData } from "presentation/utils/functions/generic";

import classroomsStudentsService from "presentation/services/classroom-students";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

class SelectStudentEvaluationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            students: [],
            validDates: []
        };

    }

    componentDidMount() {
        this.loadData();
    }


    defaultSubmit = async () => {

        let { classroomId, component } = this.props;
        let { form } = component.state;

        this.setState({ loading: true, error: '' });

        let hasInvalidInfo = !form.studentId;
        if (hasInvalidInfo) {
            this.setState({ loading: false, error: true, message: "Por favor, selecione um aluno" });
        } else {
            const { students } = this.state;

            const item = students.find(x => x.student.id == form.studentId);



            const registration = item.student?.registration ?? item.studentId ?? "";
            const displayName = item.student.person?.displayName ?? "";

            let targetUrl = `/turmas/${classroomId}/lancamento-de-notas/aluno`;
            let destination = { pathname: targetUrl, state: { studentId: form.studentId, studentRegistration: registration, studentName: displayName } };
            goTo(destination, component);
        }
    };

    loadData = async () => {
        const { classroomId } = this.props;
        this.setState({ loading: true });
        let handledResult = [];


        await classroomsStudentsService.search({ classroomId: classroomId }).then((result) => {
            handledResult = handleResultData(result);
        });

        this.setState({ loading: false, students: handledResult });
    }

    render() {
        let { show, onClose, classroomName, onSubmit, component } = this.props;
        let { loading, error, message, students } = this.state;
        const { form } = component.state;

        const hasSelection = form?.studentId || false;

        const modalSubmit = onSubmit ? onSubmit : this.defaultSubmit;

        return (
            <Modal size="lg" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{classroomName} / Lançamento de notas por aluno</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                    {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                    {loading === false && (
                        <>
                            <div className="form mt-2">
                                <Form.Label htmlFor="studentId">Aluno</Form.Label>
                                <Form.Select
                                    aria-label="Aluno"
                                    id="studentId"
                                    name="studentId"
                                    defaultValue={form?.studentId || undefined}
                                    onChange={async (e) => await handleChange(e, component)}
                                    aria-describedby="studentIdHelpBlock"
                                    required
                                >
                                    <option value={-9999}>Selecione um aluno</option>
                                    {students.map((e, i) => { return <option key={e.studentId} value={e.studentId}>{e.student.person.displayName}</option> })}
                                </Form.Select>
                                <Form.Text id="studentIdHelpBlock" muted>
                                    Escolha um aluno para realizar o lançamento de notas
                                </Form.Text>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <Button disabled={loading || !hasSelection} variant="success" onClick={() => modalSubmit()}>
                        Iniciar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
}

export default SelectStudentEvaluationModal;